import { createSelector } from 'reselect'

export const getData = state => state.reportVehicleChecks.getIn(['all', 'objects'])
export const createGetDataSelector = () => createSelector([getData], data => data)
